export const GoogleAnalyticsCategory = {
	BUTTON_CLICK: 'button_click',
	ACTION_STATUS: 'action_status',
};

export const GoogleAnalyticsAction = {
	GENERATE_CLICK: 'generate_click',
	PAYMENT_SUCCESS: 'payment_success',
	SIGN_IN_SUCCESS: 'sign_in_success',
};
